<template>
	<div>
		<b-datepicker
			v-model="dates"
			:placeholder="placeholder"
			range
			icon="calendar-alt"
			:disabled="!picker"
			:date-formatter="dateFormatter"
			:max-date="new Date()"
			:size="size"
			@input="inputDate"
		>
		</b-datepicker>
	</div>
	<!-- <div class="datepicker-holder">
		<div class="datepicker-trigger">
			<b-input
				autocomplete="off"
				icon="calendar"
				id="datepicker-trigger"
				placeholder="Select dates"
				:disabled="!picker"
				:value="formatDates(start, end)"
			/>

			<airbnb-style-datepicker
				v-if="picker"
				:date-one="start"
				:date-two="end"
				min-date="2018-06-01"
				:end-date="nonSelectDate"
				:fullscreen-mobile="true"
				:mode="'range'"
				:trigger-element-id="'datepicker-trigger'"
				@apply="applyDate"
				@cancelled="cancelDate"
				@date-one-selected="setStart"
				@date-two-selected="setEnd"
			/>
		</div>
	</div> -->
</template>

<script>
import { date_long, date_server } from "@lab/utils/format";

export default {
	props: {
		start: {
			type: String,
			default: () => {
				var date = new Date();
				date.setDate(date.getDate() - 7);
				return date_server(date);
			}
		},
		end: {
			type: String,
			default: () => {
				var date = new Date();
				date.setDate(date.getDate());
				return date_server(date);
			}
		},
		nonSelectDate: {
			type: String,
			default: () => {
				var date = new Date();
				date.setDate(date.getDate());
				return date_server(date);
			}
		},
		picker: {
			type: Boolean,
			default: () => false
		},
		size: {
			type: String,
			default: () => null
		}
	},
	data() {
		return {
			dateFormat: "d MMM yyyy",
			startDate: "",
			endDate: "",
			startUpdated: "",
			endUpdated: "",
			changed: false,
			dates: []
		};
	},
	computed: {
		placeholder() {
			return this.formatDates(this.start, this.end);
		}
	},
	watch: {
		picker(value) {
			if (value) {
				this.dates = [new Date(this.start), new Date(this.end)];
			} else {
				this.dates = [];
			}
		}
	},
	methods: {
		dateFormatter(date) {
			if (date) {
				return this.formatDates(date[0], date[1]);
			}
		},
		formatDates(dateOne, dateTwo) {
			let formattedDates = "";
			if (dateOne) {
				formattedDates = date_long(dateOne);
			}
			if (dateTwo) {
				formattedDates += " - " + date_long(dateTwo);
			}
			return formattedDates;
		},
		inputDate(value) {
			if (value.length) {
				this.startUpdated = date_server(value[0]);
				this.endUpdated = date_server(value[1]);
				this.applyDate();
			}
		},
		setStart(value) {
			this.startUpdated = value;
		},
		setEnd(value) {
			this.endUpdated = value;
		},
		applyDate() {
			this.$emit("apply", { value: this.startUpdated, position: "start" });
			this.$emit("apply", { value: this.endUpdated, position: "end" });
		},
		cancelDate() {
			if (this.changed) {
				this.startDate = this.start;
				this.endDate = this.end;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.datepicker-holder {
	width: 240px;
}
</style>
